import React, { useEffect, useState } from 'react';
import { Switch, Route, Redirect,useParams } from 'react-router-dom';
import { Spin, Space, Row, Col, Divider, List, Avatar, Card, Modal, Tooltip,Table, Image } from 'antd';
import { history } from '../../redux/store';

import axios from "axios";
import moment from 'moment';
import _ from 'underscore';
import setting from '../../config/setting'
import logo from '../../assets/img/wss_logo.png';


const VaccinationDetails = () => {

  const [CovidTestData, setCovidTestData] = useState([]);
  const [change, setChange] = useState(false);

  const locData = useParams();


  useEffect(() => {

    getTestData();

  }, [])

  function getTestData() {

    if(locData && locData["token"] && locData["testName"])
    {

      axios.post(setting.serverUrl + '/api/CovidTestQRData', {
        params:
        {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          pass: localStorage.getItem('myPass'),
          token: locData["token"],
          testName : locData["testName"]
        }
      }).then(response => {
          console.log("Respone from getTestData CovidTestQRData", response.data)
          if (response && response.data && response.data.length>0) {

            setCovidTestData(response.data[0]);
            setChange(!change)
          } else {
              console.log("Token  id", locData["token"])
              window.location.replace('https://wssrtpcrdocs.s3.amazonaws.com/raw_results_file/'+locData["token"]+".pdf")
          }
      })
    }

  }

  // console.log("CovidTestData::",CovidTestData)

  return (
    <div style={{ padding: 30, overflowY:'auto' }}>
      {Object.keys(CovidTestData).length > 0 ?
        <div className='row'>
          <div className='col-md-4'></div>
          <div className='col-md-4'>
            <div style={{ textAlign: 'center', marginBottom:40 }}>
              <i className='fa fa-check' style={{ padding: 5, fontSize: 19, borderRadius: 50, border: '1px solid green', color: 'white', backgroundColor: 'green' }}></i>
              &nbsp;<span style={{ fontWeight: 700, fontSize: 20 }}>VERIFIED!</span>
            </div>
            <Card style={{ background: 'rgba(217, 216, 216)', marginTop: 10 }} className='animated with-shadow'>
              <div><Image src={logo} width={130} /></div>
              <hr style={{width:'100%', height:1, marginBottom:10, marginTop:10}} />
              <div className='count' >
                <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Name : </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.employee.length > 0 && CovidTestData.employee[1]}</span><br />
                {/* <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Client : </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.company.length > 0 && CovidTestData.company[1]}</span><br /> */}
                {/* <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Location : </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.child_ids.length > 0 && CovidTestData.child_ids[1]}</span><br /> */}
                <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Provider : </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;Workplace Safety Screenings</span><br />
                <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Birth date: </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.dob && moment(CovidTestData.dob).format("LL")}</span><br />
                <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Test: </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{locData["testName"] && locData["testName"]=='antigen'?'COVID-19 Antigen Test':locData["testName"] && locData["testName"]=='rtpcr'?'COVID-19 RT-PCR Test':''}</span><br />
                <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Test Result: </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.test_result=='Negative'?<span style={{color:'green'}}>{CovidTestData.test_result}</span>:<span style={{color:'red'}}>{CovidTestData.test_result}</span>}</span><br />
                {locData && locData["testName"]=='rtpcr' && <span><span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Test Date: </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.test_date && moment.utc(CovidTestData.test_date).local().format("MMM Do YYYY h:mm A")}</span><br /></span>}
                <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Collection Date: </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.collection_date && moment.utc(CovidTestData.collection_date).local().format("MMM Do YYYY h:mm A")}</span><br />
                <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Sample Type: </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.sample_type && CovidTestData.sample_type}</span><br />
                {/* <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Status: </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.testing_status && CovidTestData.testing_status}</span><br /> */}
              </div>
            </Card>
            <br />
            <div style={{ fontWeight: 700, fontSize: 17, textAlign: 'center' }}>
              {/* <span >
                To Verify a Covid-19 Vaccination Certificate QR Code, click Scan button.
              </span> */}
            </div>
          </div>

        </div>
        :
        <Row>
          <Col span={10}>
          </Col>
          <Col span={8}>
            <Space size="middle" style={{ marginTop: 40 }}>

              <Spin size="large" />
            </Space>
          </Col>
        </Row>
      }
    </div>
  );
};



export default VaccinationDetails;
